import AssignProductTable from "./assignProductTable.container";

export default AssignProductTable;
